import { Stack, styled } from "@mui/material";
import GaugeChart from "react-gauge-chart";
import React from "react";
import { Typography } from "core";
import { useTranslation } from "react-i18next";

const StyledTopPost = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.section,
  padding: "2rem",
}));
export default function TopPost() {
  const { t: home } = useTranslation('home')

  return (
    <StyledTopPost spacing={3}>
      <Stack textAlign="center">
        <GaugeChart
          id="gauge-chart2"
          nrOfLevels={3}
          colors={["#A0E23A", "#72CB9D", "#5C9FBC"]}
          percent={0.86}
          arcWidth={0.3}
          cornerRadius={0}
          arcPadding={0.02}
          hideText
          animate={true}
        />
        <Typography fontWeight={800} color_variant="lightGrey" size="xsmall">
          {home('your_engagement_level')}
        </Typography>
        <Typography fontWeight={900} sx={{ color: "#000" }}>
          {home('good')}
        </Typography>
      </Stack>
    </StyledTopPost>
  );
}
